const ENV_BASE = {
  LOCAL: 'local',
  DEV: 'dev',
  STAGING: 'stg',
  PRODUCTION: 'payments',
};

export const getEnvironmentLabel = ({ href = '', hostname = '' } = {}) => {
  if (href.includes(ENV_BASE.LOCAL)) {
    return 'local';
  }
  if (href.includes(ENV_BASE.DEV)) {
    return 'dev';
  }
  if (href.includes(ENV_BASE.STAGING)) {
    return 'staging';
  }
  if (hostname.startsWith(ENV_BASE.PRODUCTION)) {
    return 'prod';
  }
  return 'unknown';
};
